import { Typography } from '@jouzen/ecom-components/v3/Typography';
import { cx } from 'class-variance-authority';
import { useTranslations } from 'next-intl';

import Image from '@/app/components/Image';
import RichText from '@/app/components/RichText';

import reasonsToBuyData from './_data/reasonsToBuyData';

const BuyWithConfidenceSection = () => {
  const t = useTranslations();
  return (
    <section
      className="relative mx-6 my-16 flex grow overflow-hidden rounded-3xl md:mx-15 md:my-20 md:rounded-[60px]"
      data-cy="buy-with-confidence-section"
    >
      <Image
        src="store/bg-buy-direct.png"
        localizedAlt="buy_with_confidence_bg_alt"
        fill
        className="object-cover"
        sizes="100vw"
      />
      <div className="relative top-0 z-10 flex w-full flex-col justify-center px-6 py-10 md:pt-23 md:pb-18">
        <Typography
          variant="h3"
          Element="h2"
          font="serif"
          className="mb-8 text-center text-white md:mb-10 lg:mb-12"
        >
          {t('buy_with_confidence_title')}
        </Typography>
        <div className="grid w-fit grid-cols-1 gap-x-12 gap-y-6 self-center md:grid-cols-2 md:gap-y-12 lg:grid-cols-3 xxl:gap-x-24">
          {reasonsToBuyData.map(({ Icon, ...reason }) => (
            <div
              key={reason.title}
              className="flex w-[260px] items-start text-white md:flex-col md:items-center"
              data-cy="reason-to-buy"
            >
              <Icon
                className={cx(
                  'size-6 max-md:mr-4 md:mb-4',
                  reason.iconClassName,
                )}
              />
              <div className="flex flex-col items-start md:items-center">
                <Typography className="text-center text-white md:text-xl lg:text-2xl lg:tracking-tighter">
                  <RichText messageKey={reason.title} />
                </Typography>
                <Typography
                  color="disabled"
                  className="text-center text-xs tracking-tight md:text-base md:tracking-tighter"
                >
                  <RichText messageKey={reason.description} />
                </Typography>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BuyWithConfidenceSection;
